<template lang="html">
	<section class="sub-main take-place column actualities">
		<div class="sub-nav-white row">
			<router-link :to="{ name: link.name }" class="item" v-for="(link, key) in menu" v-bind:key="key">
				{{ link.label }}
			</router-link>
		</div>
		<router-view></router-view>
	</section>
</template>

<script>
export default {
	name: 'IndexActualities',
	data () {
		return {
			menu: [
				{ label: 'Mon actualité', name: 'MyActualities' },
				{ label: 'Toute l\'actualité', name: 'AllActualities' },
				{ label: 'Banque de conseils', name: 'BanqueOfConseils' }
			]
		}
	},
	mounted () {
		this.$store.dispatch('fetchAllNews')
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/Actualities/IndexActualities.vue